import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VerifyOtpHandler,createOtp } from "@src/store/slices/user";
// import * as HELPER from "@src/config/helper";
// import { ROLE_FEATURES } from '@src/config/constant';
import AddApplicationThankPopup from '@src/pages/insurance/AddApplicationThankPopup';
import { MAX_OTP_TIMER, STATUS_CODES } from '@src/config/constant';

interface VerifyOtpProps {
    inputField: {
        name : string,
        email: string;
        password: string;
        captcha: string;
        hash: string;
        mobile: string;
        source: string;
    };
    userId: string;
    otp: string;
    submitButton: () => Promise<void>;
    setShowVerify: React.Dispatch<React.SetStateAction<boolean>>;
    setInputField: React.Dispatch<React.SetStateAction<any>>;
}

interface OtpRequest {
    name?:string;
    email: string;
    password?: string;
    captcha?: string;
    resendOtp?: boolean;
    otp?: string;
    hash?: string;
    mobile?: string;
    source?: string;
}


const VerifyOtp: React.FC<VerifyOtpProps> = (props) => {
    const maxTime = MAX_OTP_TIMER;
    const [errField, setErrField] = useState<any>({});
    const [inputField, setInputField] = useState({
        ...props.inputField, otp: ""
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showThankyouPopup, setShowThankyouPopup] = useState(false);

    useEffect(() => {
        //     setInputField({ ...inputField, user_id : props.userId })
    }, [props.userId]) // eslint-disable-line react-hooks/exhaustive-deps

    const [otpTimer, setOtpTimer] = useState(maxTime);


    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {

        const { name, value } = e.target;
        // Limit to 6 digits 
        const numericValue = value.replace(/\D/g, '');
        const limitedValue = numericValue.slice(0, 6);

        setInputField({ ...inputField, [name]: limitedValue, password: inputField.password });
        errField[name] = '';
        setErrField({ ...errField });
    };


    useEffect(() => {
        let startInterval: NodeJS.Timeout;
        if (otpTimer >= 0) {

            startInterval = setInterval(() => {
                setOtpTimer((val) => val - 1)

            }, 1000)
        } else {
            setOtpTimer(-1)
        }

        return () => {
            clearInterval(startInterval)

        }
    }, [otpTimer])

    const navigateToLogin = () => {
        setShowThankyouPopup(false);
        navigate("/login");
    }

    const submitButton = async () => {
        if (validForm()) {
            setLoading(true);
            try {

                const otpRequestData: OtpRequest = {
                    email: inputField.email,
                    otp: inputField.otp,
                };
                const response: any = await VerifyOtpHandler(otpRequestData, dispatch);
                setLoading(false);
                if (response.status === STATUS_CODES['success']) {
                    props.setInputField({
                        name : "",
                        email: "",
                        password: "",
                        captcha: "",
                        hash: "",
                        mobile: "",
                        otp: ""
                    });
                    // props.setShowVerify(false);
                    setShowThankyouPopup(true);
                }
            } catch (error) {
                // Handle any errors here
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };



    //For validation

    const validForm = () => {
        let formIsValid = true;
        setErrField({
            captchErr: ""
        });
        if (inputField.otp === "" || inputField.otp.trim() === '') {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                otp: 'Otp is required',
            }));
        }
        return formIsValid;
    };

    /**
     * Resend OTP Handler
     */
    const resendOtp = () => {
        if (otpTimer < 0) {
            const registerRequestData: OtpRequest = {
                name : inputField.name,
                email: inputField.email,
                mobile : inputField.mobile,
            };
            createOtp(registerRequestData).then(res => setOtpTimer(maxTime))
        }
    }

    return (
        <>
            <AddApplicationThankPopup show={showThankyouPopup} handleClose={() => {
                    setShowThankyouPopup(false)
                }} screenType="REGISTER" navigateToLogin={navigateToLogin}/>
            <div>
                <fieldset className="">
                    <div className="material">
                        <input
                            type="number"
                            placeholder=" "
                            name="otp"
                            value={inputField.otp}
                            className="form-input "
                            onChange={inputHandler}
                        />
                        <i className="ic-otp icn-login">
                            <i className='path1'></i>
                            <i className='path2'></i>
                            <i className='path3'></i>
                            <i className='path4'></i>
                        </i>

                        <label data-label='Otp' className="form-label"></label>
                        {errField.otp && (
                            <span className="error-txt">
                                {errField['otp'] || ""}
                            </span>
                        )}
                    </div>
                    {
                        <p onClick={resendOtp} className={`resend-otp-txt ${otpTimer < 0 ? 'resend-otp' : ''}`}>{otpTimer < 0 ? 'Resend Otp' : 'resend otp after ' + (otpTimer > 9 ? "0:" + otpTimer : "0:0" + otpTimer) + " seconds"}</p>
                    }


                </fieldset>

                <button type="button" className="btn-primary" onClick={submitButton} disabled={loading}>
                    Verify Otp
                </button>

            </div>
        </>
    )
}

export default VerifyOtp